
<template>
  <div class="home">
    <el-container class="container">
      <el-header v-if="!isLogin" class="header">
        <div>
          <div class="logo-home">
            <img src="~@/assets/img/topimg2.png" style="color:white">
          </div>
          <div class="nav">
            <el-menu
              mode="horizontal"
              class="menu-box el-menu-demo"
              text-color="#fff"
              active-text-color="#ffd04b"
            >
              <el-menu-item index="1">
                首页
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="topRight">
          <el-avatar icon="el-icon-user-solid" />
          <el-link
            class="li"
            @click="showlogin"
          >
            登录
          </el-link>
          <el-link
            class="li"
            @click="showreg"
          >
            注册
          </el-link>
        </div>
      </el-header>

      <el-header v-else class="header">
        <div>
          <div class="logo-home">
            <img src="~@/assets/img/topimg2.png">
          </div>
          <div class="nav">
            <el-menu
              mode="horizontal"
              class="menu-box el-menu-demo"
              text-color="#666666"
              active-text-color="#ffd04b"
            >
              <template v-for="(item,index) in menuInfo">
                <!-- 没有子菜单 -->
                <el-menu-item
                  v-if="!item.subNodes"
                  :key="index+1"
                  :index="index.toString()"
                  @click="siderClick(item)"
                >
                  <span class="colorF">{{ item.name }}</span>
                </el-menu-item>

                <!-- 有子菜单 -->
                <el-submenu
                  v-else
                  :key="index+1"
                  :index="index.toString()"
                  @click.native="getChild(item)"
                >
                  <template slot="title">
                    <span class="colorF">{{ item.name }}</span>
                  </template>
                  <template v-for="(ite,i) in item.subNodes">
                    <el-menu-item
                      v-if="(grantedPermissions[ite.auth] || !ite.auth) && !ite.subNodes"
                      :key="ite.url"
                      :index="index+'-'+i"
                      @click="siderClick(ite)"
                    >
                      {{ ite.name }}
                    </el-menu-item>
                    <el-submenu
                      v-if="(grantedPermissions[ite.auth] || !ite.auth) && ite.subNodes"
                      :key="ite.url"
                      :index="index+'-'+i"
                    >
                      <template slot="title">
                        <span>{{ ite.name }}</span>
                      </template>
                      <template v-for="(ite2,j) in ite.subNodes">
                        <el-menu-item
                          v-if="(grantedPermissions[ite2.auth] || !ite2.auth)"
                          :key="ite2.url"
                          :index="index+'-'+j"
                          @click="siderClick(ite2)"
                        >
                          {{ ite2.name }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                </el-submenu>
              </template>
            </el-menu>
          </div>
        </div>
        <div class="topRight">
          <!-- 事件 -->
          <el-tooltip content="任务" placement="bottom" effect="light">
            <el-link @click="handleEvent()">
              <i class="el-icon-set-up img-icon" />
            </el-link>
          </el-tooltip>
          <!-- 日程 -->
          <el-tooltip content="日程" placement="bottom" effect="light">
            <el-link @click="handleCalendar()">
              <i class="el-icon-date img-icon" />
            </el-link>
          </el-tooltip>
          <!-- 通知 -->
          <el-tooltip content="通知" placement="bottom" effect="light">
            <el-link @click="handleNotice()">
              <i class="el-icon-chat-dot-round img-icon" />
            </el-link>
          </el-tooltip>
          <template>
            <router-link to="/gr/profile">
              <el-avatar
                v-if="!userImg"
                icon="el-icon-user-solid"
              />
              <el-avatar
                v-if="userImg"
                :src="userImg"
              />
            </router-link>
            <router-link to="/gr/profile" style="padding-top:3px">
              <span class="nickName">{{ nickName }}</span>
            </router-link>
          </template>
          <el-link
            :underline="false"
            class="li"
            @click="logout()"
          >
            退出
          </el-link>
        </div>
      </el-header>

      <el-main class="main">
        <div class="box01">
          <img src="~@/assets/img/bg_1.png">
          <div class="text01">
            <div v-if="!isLogin">
              <h1 style="font-family:方正舒体;font-size:70px">科学·管理·效率</h1>
            </div>
            <div v-else>
              <!-- <h1>科学·管理·效率</h1>
            <p>Technical & Management & Efficiency</p> -->
              <p style="margin-top:80px">
                <img height="200%" src="~@/assets/img/logo_new.png" class="img-center">
              </p>
              <p style="margin-top:40px">
                <img style="width:500px !important" src="~@/assets/img/sub_title.png">
              </p>
              <!-- <h1 style="color:#5E0606">团结 求实 创新</h1> -->
              <!-- <h1 style="font-family:方正舒体;font-size:70px">团结 求实 创新</h1> -->
              <!-- <p style="font-family:方正舒体;font-size:28px">上海市中西医结合脉管病研究所</p>
            <p style="font-family:Segoe Print">Shanghai TCM-Integrated Institute of Vascular Anomalies</p> -->
              <p style="margin-top:120px">
                <img width="80px !important" src="~@/assets/img/mys_1.png">
              </p>
            </div>
          </div>
        </div>
        <div class="box02" style="display:none">
          <h2>行业顶尖专家 全球前沿资讯</h2>
          <p class="text">
            50000+科学专家入驻，共筑前沿科技
          </p>
          <div class="home-row">
            <el-row :gutter="30">
              <el-col
                :span="24"
                class="card-box"
              >
                <el-card shadow="always">
                  <p class="title">
                    站内科学家排名
                  </p>
                  <el-tabs v-model="activeName1">
                    <el-tab-pane
                      label="分类一"
                      name="first"
                    >
                      <el-row
                        :gutter="20"
                        class="list"
                      >
                        <el-col :span="4">
                          <div class="people-info-l">
                            <img
                              src="~@/assets/img/face.png"
                              alt="..."
                              class="expert-face"
                            >
                          </div>
                        </el-col>
                        <el-col
                          :span="14"
                          class="people-info-m"
                        >
                          <h4>名字1</h4>
                          <div class="text-md-left">
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div class="rank-text">
                            TOP 1
                          </div>
                        </el-col>
                      </el-row>
                      <el-row
                        :gutter="20"
                        class="list"
                      >
                        <el-col :span="4">
                          <div class="people-info-l">
                            <img
                              src="~@/assets/img/face.png"
                              alt="..."
                              class="expert-face"
                            >
                          </div>
                        </el-col>
                        <el-col
                          :span="14"
                          class="people-info-m"
                        >
                          <h4>名字1</h4>
                          <div class="text-md-left">
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div class="rank-text">
                            TOP 2
                          </div>
                        </el-col>
                      </el-row>
                      <el-row
                        :gutter="20"
                        class="list"
                      >
                        <el-col :span="4">
                          <div class="people-info-l">
                            <img
                              src="~@/assets/img/face.png"
                              alt="..."
                              class="expert-face"
                            >
                          </div>
                        </el-col>
                        <el-col
                          :span="14"
                          class="people-info-m"
                        >
                          <h4>名字1</h4>
                          <div class="text-md-left">
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div class="rank-text">
                            TOP 3
                          </div>
                        </el-col>
                      </el-row>
                      <el-row
                        :gutter="20"
                        class="list"
                      >
                        <el-col :span="4">
                          <div class="people-info-l">
                            <img
                              src="~@/assets/img/face.png"
                              alt="..."
                              class="expert-face"
                            >
                          </div>
                        </el-col>
                        <el-col
                          :span="14"
                          class="people-info-m"
                        >
                          <h4>名字1</h4>
                          <div class="text-md-left">
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                            <el-tag
                              type="info"
                              effect="plain"
                            >
                              标签一
                            </el-tag>
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <div class="rank-text">
                            TOP 4
                          </div>
                        </el-col>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane
                      label="分类二"
                      name="second"
                    >
                      分类二
                    </el-tab-pane>
                    <el-tab-pane
                      label="分类三"
                      name="third"
                    >
                      分类三
                    </el-tab-pane>
                  </el-tabs>
                </el-card>
              </el-col>
            </el-row>
          </div>
          <el-button
            class="about-more"
            type="primary"
            round
          >
            查看更多
          </el-button>
        </div>

        <!-- box3 -->
        <div class="box03" style="display:none">
          <h2>科学·家 商城</h2>
          <p class="text">
            全国知名耗材供应商为您提供一站式服务
          </p>
          <div class="inner03">
            <div class="seach-box">
              <el-input
                placeholder="请输入内容"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  type="warning"
                  icon="el-icon-search"
                >
                  搜索
                </el-button>
              </el-input>
            </div>
            <div class="block">
              <el-carousel
                trigger="click"
                height="300px"
              >
                <el-carousel-item
                  v-for="item in 4"
                  :key="item"
                >
                  <h3>{{ item }}</h3>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <el-button
            class="about-more"
            type="warning"
            round
          >
            查看更多
          </el-button>
        </div>

        <!-- box 4 -->
        <div class="box04" style="display:none">
          <el-card class="box-card">
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="innner04">
                  <h2>
                    <a
                      href="#"
                      class="fr"
                    >查看全部</a>科研资讯
                  </h2>
                </div>

                <dl class="zhaop">
                  <dt>2010-10-10</dt>
                  <dd>资讯01</dd>
                  <dt>2010-10-10</dt>
                  <dd>资讯02</dd>
                  <dt>2010-10-10</dt>
                  <dd>资讯03</dd>
                  <dt>2010-10-10</dt>
                  <dd>资讯04</dd>
                  <dt>2010-10-10</dt>
                  <dd>资讯05</dd>
                </dl>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-main>
      <el-footer class="footer">
        <el-row
          :gutter="20"
          class="footer-box"
        >
          <el-col :span="7">
            <h4 class="text-uppercase">
              关于我们
            </h4>
            <ul class="list-unstyled">
              <li>
                <a href="#">合作</a>
              </li>
              <li>
                <a href="#">加入我们</a>
              </li>
            </ul>
          </el-col>
          <el-col :span="7">
            <h4 class="text-uppercase">
              企业服务
            </h4>
            <ul class="list-unstyled">
              <li>
                <a href="#">企业服务</a>
              </li>
              <li>
                <a href="#">合作方式</a>
              </li>
            </ul>
          </el-col>
          <el-col :span="10">
            <h4 class="text-uppercase">
              联系我们
            </h4>
            <ul class="list-unstyled">
              <li>联系电话：021-98776562</li>
              <li>邮箱：service@scihome365.com</li>
              <li>地址：上海市杨浦区XXX路999号501室</li>
            </ul>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import pathReq from '../../api/pathlist'
import comInfo from '../../layouts/Config'
import config from '@/config'

export default {
  data() {
    return {
      activeName1: 'first',
      activeName: 'first',
      nickName: '',
      menuInfo: comInfo.menuInfo,
      grantedPermissions: '',
      isLogin: false,
      baseURL: config.apiHost,
      userImg: ''
    }
  },
  computed: {},
  watch: {},

  created() {
    this.$bus.on('reloadShow', () => {
      this.isLogin = localStorage.getItem('isLogin')
      this.getAll()
      this.getCurrentLoginInformations()
    })

    if (localStorage.getItem('isLogin')) {
      this.isLogin = localStorage.getItem('isLogin')
      this.getAll()
      this.getCurrentLoginInformations()
    }
  },
  mounted() {},
  methods: {
    // 点击侧边栏
    siderClick(item) {
      this.$router.push(item.path)
    },

    showlogin() {
      this.$bus.emit('show/login')
    },

    showreg() {
      this.$bus.emit('show/reg')
    },
    // 退出
    logout() {
      this.$confirm('确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.setItem('logout-path', this.$route.path)
        localStorage.removeItem('accessToken')
        localStorage.removeItem('encryptedAccessToken')
        localStorage.removeItem('isLogin')
        localStorage.removeItem('userId')

        this.$nextTick(() => {
          this.$router.push('/')
        })

        this.isLogin = false
      })
    },

    // 获取信息
    getAll() {
      const path = '/AbpUserConfiguration/GetAll'
      pathReq.postForm(path).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            this._data.grantedPermissions =
              res.data.result.auth.grantedPermissions
            const grantedPermissions = JSON.stringify(
              res.data.result.auth.grantedPermissions
            )

            sessionStorage.setItem('grantedPermissions', grantedPermissions)
            window.localStorage.setItem('grantedPermissions', grantedPermissions)
          }
        }
      })
    },
    // 跳导航
    getChild(item) {
      console.log(item)
      this.$router.push({ name: 'navi', query: { 'naviInfo': JSON.stringify(item) }})
    },
    /** 事件 */
    handleEvent() {
      this.$router.push({ name: 'evenement' })
    },
    /** 日历 */
    handleCalendar() {
      this.$router.push({ name: 'calendar' })
    },
    /** 通知 */
    handleNotice() {
      this.$router.push({ name: 'notice' })
    },
    // 获取用户信息
    getCurrentLoginInformations() {
      const path = '/api/services/app/Session/GetCurrentLoginInformations'
      pathReq.getNoParams(path).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            console.log(123)
            console.log(res.data.result.user)
            if (res.data.result.user != null) {
              const nickName = res.data.result.user.nickName
              this._data.nickName = nickName
              window.localStorage.setItem('nickName', nickName)
              this.userImg = this.baseURL + '/api/EndUserInfo/LoadUserImage?userId=' + res.data.result.user.id
            } else {
              this.isLogin = false
            }

            this.$nextTick(() => {
              this.$router.push('/')
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: none !important;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  text-align: center;
}
.colorF {
  color: #fff;
}
.menu-box {
  background: none;

  font-size: 16px;
}

.menu-box a {
  color: #fff;
  background: none;
}

.logo-home {
  width: 100px;
  float: left;
  text-align: center;
}
.logo-home img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

.topRight {
  float: right;
  vertical-align: middle;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #fff;
}

.topRight .li {
  margin-left: 10px;
}
.img-icon {
  width: 30px;
  font-size: 30px;
  margin-right: 10px;
}
.nav {
  padding-left: 10px;
  float: left;
  font-size: 18px;
}

.container {
  padding: 20px 0 0 0;
  height: 100%;
}

.main {
  padding: 0;
  margin-top: -80px;
}

.main .box01 {
  position: relative;
}
.main .box01 img {
  width: 100%;
}

.header {
  height: auto !important;
  position: relative;
  z-index: 99;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 1100px;
  justify-content: space-between;
}

.nav .el-menu--horizontal {
  border: none;
  font-size: 18px;
}

.text01 {
  font-size: 32px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
}

.text01 h1 {
  font-size: 42px;
}
.text01 p {
  font-size: 20px;
}

.el-link.el-link--default {
  color: #fff;
}

.box02 {
  margin-top: -10px;
  padding-top: 80px;
  text-align: center;
  background: url(~@/assets/img/bg_2.png) no-repeat center top;
}
.box02 h2,
.box03 h2,
.box04 h2 {
  font-size: 36px;
  font-weight: 400;
}

.box04 h2 {
  font-size: 30px;
}

.box02 h2 a,
.box03 h2 a,
.box04 h2 a {
  padding-right: 20px;
  font-size: 16px;
  padding-top: 20px;
  color: #1d89e0;
}

.box02 p.text,
.box03 p.text {
  margin-bottom: 50px;
  font-size: 16px;
}

.home-row {
  width: 1000px;
  margin: 0 auto;
}
.title {
  font-size: 30px;
  margin: 20px 0 10px;
}

.card-box .el-card {
  height: 490px;
}

.people-info-l {
  width: 60px;
}
.people-info-l img {
  width: 100%;
}
.el-tag {
  margin-right: 5px;
  border-radius: 20px;
  height: 28px;
  line-height: 28px;
  color: #666;
}

.el-tag--plain.el-tag--info {
  color: #333;
}
.people-info-m {
  text-align: left;
}

.people-info-m h4 {
  font-size: 16px;
  margin-bottom: 5px;
}
.rank-text {
  font-family: "Arial Black", Helvetica, sans-serif;
  color: #ffc059;
  font-size: 20px;
  padding-top: 15px;
}
.list {
  margin-bottom: 10px;
}
.about-more {
  width: 220px;
  margin: 30px 0 30px 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
}

.box03 {
  margin-top: -10px;
  padding-top: 80px;
  color: #fff;
  text-align: center;
  background: url(~@/assets/img/timg.png) no-repeat center top;
}
.inner03 {
  width: 1000px;
  margin: 0 auto;
}

.seach-box {
  width: 80%;
  margin: 0 auto 20px;
}
.el-input-group__append button.el-button {
  background: #ffc059;
  color: #fff;
  width: 120px;
}

.box04 {
  padding: 80px 0 40px 0;
  width: 1000px;
  margin: 0 auto;
}

.box04 .box-card {
  height: 490px;
  padding: 30px;
}

.zhaop {
  font-size: 18px;
  line-height: 1.8;
  margin-top: 15px;
}

.zhaop dt {
  padding: 5px 0;
  float: right;
}

.zhaop dd {
  padding: 5px 10px;
  border-bottom: 1px solid #f2f2f2;
}
.footer {
  text-align: center;
  background: #f3f3f3;
  padding-top: 80px;
  padding-bottom: 80px;
  height: auto !important;
}

.footer-box,
.footer-box a {
  text-align: left;
  margin: 0 auto !important;
  width: 900px;
  font-size: 14px;
  line-height: 1.9;
  color: #5f5f5f;
}

.footer-box h4 {
  margin-bottom: 10px;
  font-size: 18px;
  color: #333;
}

.nickName {
  margin-left: 5px;
  color: #fff;
  line-height: 40px;
  font-weight: bold;
}
.img-center{
    width: auto;
    height: auto;
    max-width: 300px;
    max-height: 100%;
}

/* ffc059 */
</style>
